import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum WebhookEventStatus {
  Pending = 1,
  Sent = 2,
  Failed = 3,
  Generated = 4,
  Retry = 5,
}
EnumDescriptions.setDescriptions(WebhookEventStatus, [
  i18n.t('enums.pending'),
  i18n.t('enums.sent'),
  i18n.t('enums.failed'),
  i18n.t('enums.generated'),
  i18n.t('enums.retry'),
]);
